const KEY = "reframe:chunk-recovery";
const RETRY_WINDOW_MS = 60_000;

/**
 * Open tabs can request an old lazy chunk while a new build is being served.
 * Reload once to get the current HTML/manifest, never loop on a real outage.
 * If storage is unavailable, leave the original error visible.
 */
export function installChunkRecovery(target = window, now = Date.now) {
  const recover = (event) => {
    const timestamp = now();
    try {
      const previous = Number(target.sessionStorage.getItem(KEY));
      if (previous && timestamp - previous < RETRY_WINDOW_MS) return;
      target.sessionStorage.setItem(KEY, String(timestamp));
    } catch {
      return;
    }
    event.preventDefault();
    target.location.reload();
  };
  target.addEventListener("vite:preloadError", recover);
  return () => target.removeEventListener("vite:preloadError", recover);
}
